import { useFormContext } from "react-hook-form";

import { Role } from "@models/role";
import { useOrganizationUsersForRoles } from "@queries";
import { catchUserCreationError } from "@services/user.util";
import container from "@src/container";
import { InstructorsEditor } from "@views/classrooms/creation/instructors-editor";
import { UserOptionItem } from "@views/classrooms/creation/user-option-item";

export const AddInstructorsSection = ({ classroom, creationEnabled }) => {
  const { clientCode: orgCode } = classroom;
  const { userService } = container;

  const { setValue, watch } = useFormContext();

  const { data: instructors = [], refetch: refetchInstructors } =
    useOrganizationUsersForRoles(classroom?.clientCode, [
      Role.INSTRUCTOR.id,
      Role.ORG_ADMIN.id,
    ]);

  const instructorsWatch = watch("instructors");

  const addInstructorOption = (data) => {
    const updatedSelectedOptions = [...instructorsWatch, data];
    setValue("instructors", updatedSelectedOptions);
    refetchInstructors();
  };

  const onCreateInstructor = async (data) => {
    try {
      return await createUser(data);
    } catch (error) {
      return catchUserCreationError(error, "instructor");
    }
  };

  const createUser = async (data) => {
    const instructor = await userService.createNewUser(data, orgCode);
    addInstructorOption(new UserOptionItem(instructor));
    return instructor;
  };

  return (
    <div className="instructors-section">
      <h3>Instructors</h3>
      <InstructorsEditor
        data={instructors}
        onCreateInstructor={onCreateInstructor}
        creationEnabled={creationEnabled}
      />
    </div>
  );
};
